import type { ReactNode } from 'react';
import { ResourceIconCategoryFront } from '../../../domain/models/resources.model';
import GraphicEqOutlinedIcon from '@mui/icons-material/GraphicEqOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';
export function IconCategory({ name }: { name: ResourceIconCategoryFront }): ReactNode {
  switch (name) {
    case ResourceIconCategoryFront.AUDIO:
      return <GraphicEqOutlinedIcon />;
    case ResourceIconCategoryFront.IMAGE:
      return <InsertPhotoOutlinedIcon />;
    case ResourceIconCategoryFront.PACKAGE:
      return <ArchiveOutlinedIcon />;

    case ResourceIconCategoryFront.VIDEO:
      return <SmartDisplayOutlinedIcon />;
    case ResourceIconCategoryFront.DEFAULT:
    case ResourceIconCategoryFront.TEXT:
    default:
      return <DescriptionOutlinedIcon />;
  }
}
